<template>
  <div class="row">
    <div class="col-6 offset-3">
      <div v-if="!canConfirm">
        <div class="alert alert-warning">{{ errorMessage }}</div>
      </div>
      <div v-else>
        <div>
          <div>
            <label>Password</label><br>
            <input type="password" v-model="user.password">
          </div>
          <div>
            <label>Re. password</label><br>
            <input type="password" v-model="user.password_confirmation">
          </div>
          <div>
            <br>
            <div class="btn btn-success" @click="savePassword()">Save</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {

    created() {
      this.user.email = this.$route.params.email
      this.$root.$emit('loading-page', true)
      console.log('testas')
      this.axios.post('/users/canConfirm/' + this.user.email).then(response => {
        this.$root.$emit('loading-page', false)
        this.canConfirm = response.data.canConfirm
        this.errorMessage = response.data.message

        if (!this.canConfirm) {
//          this.$router.push({name: 'login'})
        }
      })

    },

    data() {
      return {
        user: {
          email: null,
          password: null,
          password_confirmation: null,
        },
        canConfirm: false,
        errorMessage: '',
      }
    },

    methods: {
      savePassword() {
        if (this.user.password && this.user.password_confirmation && this.user.password === this.user.password_confirmation) {
          this.axios.post('/users/confirm', this.user).then(response => {
            if (response.data.success) {
              this.$router.push({name: 'login'})
              alert('Saved!')
            }
          })
        }
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/views/Users/Confirm.vue